import qs from 'qs';
import { axiosTemplate } from '../../axiosTemplate';
import { getLoaders } from '../dataLoaders';
import { endpoints } from './endpoints';
export const movIntegrationMDS = {
    endpoints,
    http: {
        // @deprecated. Use `getDatasets` method instead
        getDatasetByCapabilities: ({ stage, metjwt, params, cancelToken, headers }) => {
            const queryString = qs.stringify(params, { arrayFormat: 'comma' });
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/datasets-by-capabilities?${queryString}`);
        },
        getDatasets: ({ metjwt, stage, data, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/v2/getDatasets`, data);
        },
        getDatasetsByIds: ({ metjwt, stage, data, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/v2/getDatasetsByIds`, data);
        },
        getDataset: ({ metjwt, stage, data, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/getDataset`, data);
        },
        // @deprecated. Use `getData` method instead
        loadDataFromDatabilitiesObject: ({ stage, metjwt, params, cancelToken, headers }) => {
            const queryString = qs.stringify(params, { arrayFormat: 'comma' });
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/data-from-databilities?${queryString}`);
        },
        getData: ({ stage, metjwt, data, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/getData`, data);
        },
        getCfjsons: ({ stage, metjwt, databilities, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/getCfjsons`, { databilities });
        },
        getObservationStations: ({ stage, metjwt, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/observation-stations`);
        },
        findCapabilitiesByDataset: ({ stage, metjwt, datasetId, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/capabilities/dataset/${datasetId}`);
        },
        getCapabilitiesByDatasetIds: ({ datasetIds, metjwt, stage, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/getCapabilitiesByDatasetIds`, { datasetIds });
        },
        getVariable: ({ stage, metjwt, variableId, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/variable/${variableId}`);
        },
        getUserPrivateObservations: ({ stage, metjwt, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/observations/user`);
        },
        getAgentObservations: ({ stage, metjwt, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/observations/agents`);
        },
        superAdminAssignObservationToAgent: ({ stage, metjwt, agentId, observations, cancelToken, headers }) => {
            const data = { agentId, observations };
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/observations/super-admin/assign-to-agent`, data);
        },
        superAdminRemoveObservationFromAgent: ({ stage, metjwt, agentId, observationId, cancelToken, headers }) => {
            const data = { agentId, observationId };
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/observations/super-admin/remove-from-agent`, data);
        },
        superAdminGetAgentPrivateObservations: ({ agentId, stage, metjwt, cancelToken, headers }) => {
            const data = { agentId };
            return axiosTemplate(metjwt, cancelToken, headers).post(`${movIntegrationMDS.endpoints[stage]}/observations/super-admin/get-agent-private-observations`, data);
        },
        superAdminGetPrivateObservations: ({ stage, metjwt, cancelToken, headers }) => {
            return axiosTemplate(metjwt, cancelToken, headers).get(`${movIntegrationMDS.endpoints[stage]}/observations/super-admin/get-private-observations`);
        },
        batch: {
            getCfjson: ({ stage, metjwt, datability, signal, headers }) => {
                return getLoaders().movIntegrationMds.getCfjsonLoader.load({ stage, metjwt, datability, signal, headers });
            },
            getDataset: ({ stage, metjwt, datasetId, headers }) => {
                return getLoaders().movIntegrationMds.getDatasetLoader.load({ stage, metjwt, datasetId, headers });
            },
        },
    },
};
